import { useCTW } from '@ctw/shared/context/ctw-context';
import { useQuery } from '@tanstack/react-query';
import { useGetSupportedVitals } from './vital-write';

const useSupportedVitalsQueryKey = () => {
  const {
    requestContext: { ehr },
  } = useCTW();
  return ['supported-vitals', ehr];
};

export function useSupportedVitals() {
  const getSupportedVitals = useGetSupportedVitals();
  const queryKey = useSupportedVitalsQueryKey();

  const queryResult = useQuery({
    queryKey,
    queryFn: async () => {
      const response = await getSupportedVitals();
      return response.data.attributes;
    },
  });

  return queryResult;
}
